export default "__VITE_ASSET__C41eEKYR__"